import React, { useEffect, useState } from "react";
import { Package, PackageCheck, ShoppingCart, Clock, Loader2 } from "lucide-react";
import { adminApi } from "../../../lib/api";
import { ProfitTrendChart } from "./ProfitTrendChart";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    adminApi.get("/admin/dashboard/stats").then((r) => setStats(r.data));
  }, []);

  if (!stats) return <div className="flex justify-center py-20"><Loader2 className="animate-spin text-[#228B22]" size={28} /></div>;

  const cards = [
    { label: "Total Products", value: stats.total_products, icon: Package, color: "bg-blue-50 text-blue-600" },
    { label: "Active Products", value: stats.active_products, icon: PackageCheck, color: "bg-green-50 text-green-600" },
    { label: "Total Orders", value: stats.total_orders, icon: ShoppingCart, color: "bg-purple-50 text-purple-600" },
    { label: "Pending Orders", value: stats.pending_orders, icon: Clock, color: "bg-orange-50 text-orange-600" },
  ];

  return (
    <div className="space-y-5">
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
      {cards.map((c) => {
        const Icon = c.icon;
        return (
          <div key={c.label} data-testid={`stat-${c.label.toLowerCase().replace(/\s/g, "-")}`} className="bg-white rounded-lg border border-gray-200 p-5 shadow-sm">
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${c.color} mb-4`}><Icon size={20} /></div>
            <p className="text-3xl font-bold text-[#0A1F13]">{c.value}</p>
            <p className="text-sm text-gray-500 mt-1">{c.label}</p>
          </div>
        );
      })}
    </div>
    <ProfitTrendChart />
    </div>
  );
}
